import React, { useEffect, useState } from "react";
import { Alert, Card, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Input } from "../../components";
import {
  bacaMasalah,
  simpanHrPeriod,
} from "../../config/redux/action/sustainabilityAction";
import { formatAngka } from "../../utils";

const kosong = {
  total_employed: "",
  disability_workers: "",
  local_workers: "",
  local_definition: "",
  new_jobs_created: "",
  employment_hours: "",
  catatan: "",
};

const angkaAtauNol = (v) => (v === "" || v === null ? 0 : Number(v));

function PanelSocial({ periode, list, onSaved }) {
  const [Form, setForm] = useState(kosong);
  const [Pesan, setPesan] = useState(null);
  const [Error, setError] = useState([]);
  const dispatch = useDispatch();

  const barisPeriode = (list || []).find((val) => val.periode === periode);

  useEffect(() => {
    setPesan(null);
    setError([]);
    if (barisPeriode) {
      setForm({
        total_employed: barisPeriode.total_employed ?? "",
        disability_workers: barisPeriode.disability_workers ?? "",
        local_workers: barisPeriode.local_workers ?? "",
        local_definition: barisPeriode.local_definition ?? "",
        new_jobs_created: barisPeriode.new_jobs_created ?? "",
        employment_hours: barisPeriode.employment_hours ?? "",
        catatan: barisPeriode.catatan ?? "",
      });
    } else {
      setForm(kosong);
    }
  }, [periode, list]);

  const ubah = (key, value) => setForm({ ...Form, [key]: value });

  // POST hr-period adalah upsert yang menimpa seluruh baris, jadi semua kolom
  // harus dikirim ulang walaupun tidak diubah agar nilai lama tidak terhapus.
  const simpan = () => {
    setPesan(null);
    setError([]);
    dispatch(
      simpanHrPeriod({
        periode,
        total_employed: angkaAtauNol(Form.total_employed),
        disability_workers: angkaAtauNol(Form.disability_workers),
        local_workers: angkaAtauNol(Form.local_workers),
        local_definition: Form.local_definition || "",
        new_jobs_created: angkaAtauNol(Form.new_jobs_created),
        employment_hours: angkaAtauNol(Form.employment_hours),
        catatan: Form.catatan || "",
      })
    )
      .then((res) => {
        setPesan(res.message || "Data tersimpan.");
        onSaved();
      })
      .catch((err) => setError(bacaMasalah(err)));
  };

  const persenDisabilitas =
    barisPeriode && barisPeriode.total_employed > 0
      ? (barisPeriode.disability_workers / barisPeriode.total_employed) * 100
      : null;
  const persenLokal =
    barisPeriode && barisPeriode.total_employed > 0
      ? (barisPeriode.local_workers / barisPeriode.total_employed) * 100
      : null;

  return (
    <Row className="g-2">
      <Col xs={12} lg={5}>
        <Card className="border-0 shadow-sm h-100">
          <Card.Body className="p-3">
            <div className="fw-bold mb-2" style={{ fontSize: "13px" }}>
              Input Data Ketenagakerjaan &mdash; {periode}
            </div>
            {Error.length > 0 && (
              <Alert
                variant="danger"
                className="py-1 px-2"
                style={{ fontSize: "11px" }}
              >
                <ul className="mb-0 ps-3">
                  {Error.map((val, i) => (
                    <li key={i}>{val}</li>
                  ))}
                </ul>
              </Alert>
            )}
            {Pesan && (
              <Alert
                variant="success"
                className="py-1 px-2"
                style={{ fontSize: "11px" }}
              >
                {Pesan}
              </Alert>
            )}
            <Input
              judul="Total Pekerja"
              type="number"
              value={Form.total_employed}
              onChange={(e) => ubah("total_employed", e.target.value)}
            />
            <Input
              judul="Pekerja Penyandang Disabilitas"
              type="number"
              value={Form.disability_workers}
              onChange={(e) => ubah("disability_workers", e.target.value)}
            />
            <Input
              judul="Pekerja Lokal"
              type="number"
              value={Form.local_workers}
              onChange={(e) => ubah("local_workers", e.target.value)}
            />
            <Input
              judul="Definisi Pekerja Lokal"
              type="textarea"
              placeholder="Contoh: berdomisili dalam radius 5 km dari workshop"
              value={Form.local_definition}
              onChange={(e) => ubah("local_definition", e.target.value)}
            />
            <Input
              judul="Lapangan Kerja Baru"
              type="number"
              value={Form.new_jobs_created}
              onChange={(e) => ubah("new_jobs_created", e.target.value)}
            />
            <Input
              judul="Jam Kerja"
              type="number"
              value={Form.employment_hours}
              onChange={(e) => ubah("employment_hours", e.target.value)}
            />
            <Input
              judul="Catatan"
              type="textarea"
              value={Form.catatan}
              onChange={(e) => ubah("catatan", e.target.value)}
            />
            <div className="d-flex justify-content-end">
              <button className="btn btn-sm btn-primary" onClick={simpan}>
                {barisPeriode ? "Perbarui" : "Simpan"}
              </button>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <Col xs={12} lg={7}>
        <Card className="border-0 shadow-sm h-100">
          <Card.Body className="p-3">
            <div className="fw-bold mb-2" style={{ fontSize: "13px" }}>
              Riwayat Periode
            </div>
            {barisPeriode && (
              <div className="d-flex mb-3" style={{ fontSize: "12px" }}>
                <div className="me-4">
                  <div className="text-muted" style={{ fontSize: "10px" }}>
                    Rasio disabilitas
                  </div>
                  <div className="fw-bold">
                    {formatAngka(persenDisabilitas, 1)}%
                  </div>
                </div>
                <div>
                  <div className="text-muted" style={{ fontSize: "10px" }}>
                    Rasio pekerja lokal
                  </div>
                  <div className="fw-bold">{formatAngka(persenLokal, 1)}%</div>
                </div>
              </div>
            )}
            <div className="table-responsive">
              <table
                className="table table-bordered mb-0"
                style={{ fontSize: "11px" }}
              >
                <thead className="table-light">
                  <tr>
                    <th>Periode</th>
                    <th className="text-end">Karyawan</th>
                    <th className="text-end">Disabilitas</th>
                    <th className="text-end">Lokal</th>
                    <th className="text-end">Kerja Baru</th>
                    <th className="text-end">Jam Kerja</th>
                  </tr>
                </thead>
                <tbody>
                  {list && list.length > 0 ? (
                    list.map((val) => (
                      <tr
                        key={val.id}
                        className={
                          val.periode === periode ? "table-success" : ""
                        }
                      >
                        <td>{val.periode}</td>
                        <td className="text-end">
                          {formatAngka(val.total_employed, 0)}
                        </td>
                        <td className="text-end">
                          {formatAngka(val.disability_workers, 0)}
                        </td>
                        <td className="text-end">
                          {formatAngka(val.local_workers, 0)}
                        </td>
                        <td className="text-end">
                          {formatAngka(val.new_jobs_created, 0)}
                        </td>
                        <td className="text-end">
                          {formatAngka(val.employment_hours, 0)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} align="center">
                        Data tidak ditemukan
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default PanelSocial;
